<template>
  <With_Header_Modal_Template
      title="Покупка пакета часов"
      width="700px"
  >
    <preload-content :loading="loading" min-height="495px">
      <div class="content" v-if="!loading">
        <div class="top">
          <h3>
            <span v-if="pack.coworking">{{ pack.coworking.name }}</span>
            <span> - </span>
            <span v-if="pack.zone">{{ pack.zone.name }}</span>
          </h3>
          <div class="card">
            <div class="duration">Срок действия {{ pack.days }} дней</div>
            <div class="duration_hours">{{ pack.hours }} часов</div>
            <div class="price">{{ pack[this.isOldPrice() ? 'old_price' : 'price'] }} Р / час</div>
            <!--            <div class="price_gray">8 000 Р</div>-->
          </div>
        </div>
        <div class="payment">
          <div class="left"></div>
          <div class="right">
            <div class="payment_item">
              <div>
                <div class="desc">Общая сумма</div>
                <div class="desc">(за {{ pack.hours }} часа)</div>
              </div>
              <div class="price">{{ getTotalPrice() }} <span>Р</span></div>
            </div>
            <div class="payment_item" v-if="bonus">
              <div>
                <div class="desc">Оплата баллами</div>
                <div class="desc">({{ bonus }} баллов)</div>
              </div>
              <div class="price">-{{ bonus }} <span>Р</span></div>
            </div>
            <div class="total">
              <span>Итого</span>
              <div class="total_price">{{ getTotalPrice() - bonus }} Р</div>
            </div>
          </div>
        </div>
      </div>
    </preload-content>
    <div slot="footer" class="flex-end">
      <button class="btn-confirm" :disabled="disabledConfirm" @click="confirm()">Оформить заказ</button>
    </div>
  </With_Header_Modal_Template>
</template>

<script>
import PreloadContent from '@/components/ui/preload-content';
import With_Header_Modal_Template from '@/components/Modals/ModalsTemplate/With_Header_Modal_Template'
import {mapGetters, mapMutations} from "vuex";

export default {
  name: "Buy_Packages_Offline",
  components: {With_Header_Modal_Template, PreloadContent},
  data() {
    return {
      pack: null,
      points: 0,
      master: null,
      types: [
        {code: 'card', name: 'Онлайн-оплата картой', btn: 'Оплатить онлайн'},
        {code: 'coworking', name: 'Оплата в коворкинге', btn: 'Оформить заказ'},
      ],
      form: {pay_type: 'card', tariff_id: null},
      disabledConfirm: true,
      bonus: 0,
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    loading() {
      return !this.pack || this.bonus === null;
    }
  },
  mounted() {
    this.$eventHub.$on('packageOffline.modal.set', (master, zone, tariff) => {
      this.master = master;
      this.$api.admin.master.points(master).then(({points}) => this.points = points);
      this.$api.coworking.zone.tariff.item(this.getUser.coworking.id, tariff).then(({data}) => {
        this.pack = data;
        this.form.tariff_id = this.pack.id;
        this.disabledConfirm = false;
      });
      // this.$api.bonus.tariff({master: master, tariffs: [tariff]}).then((data) => this.bonus = data.bonus);
    });
  },
  methods: {
    ...mapMutations(['closeModals', 'setUser']),
    changePayType(e, options) {
      this.form.pay_type = options.code;
    },
    isOldPrice() {
      return this.$moment(this.pack.end_old_price_at, 'DD.MM.YYYY').diff(this.$moment(), 'second');
    },
    getTotalPrice() {
      return parseInt(this.pack.hours) * parseInt(this.pack[this.isOldPrice() ? 'old_price' : 'price']);
    },
    confirm() {
      this.disabledConfirm = true;
      this.$api.admin.master.tariff(this.master, this.form).then(({data}) => {
        if (data.redirect_url) {
          this.$toast.success('Перенаправляем на страницу оплаты');
          return setTimeout(() => window.location.href = data.redirect_url, 1000);
        }
        this.closeModals();
        this.$toast.success('Платеж покупки тарифа с оплатой в коворкинге успешно создан!');
      }).catch(({response}) => {
        if (response.data.exception) this.$toast.error(response.data.message);
        if (response.data.errors) this.$toast.error(response.data.errors[Object.keys(response.data.errors)[0]][0]);
      }).finally(() => this.disabledConfirm = false);
    }
  },
  beforeDestroy() {
    this.$eventHub.$off('packageOffline.modal.set')
  }
}
</script>

<style scoped lang="scss">
.flex-end {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

h3 {
  margin-bottom: 20px;
}

.top {
  padding-bottom: 30px;
  border-bottom: 1px solid #E5E5E5;
}

.content {
  padding: 30px;
}

.card {
  width: 280px;
  background-color: #FFFFFF;
  border: 1px solid #DBBFA7;
  border-radius: 10px;
  padding: 20px 30px;
}

.duration {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  line-height: 1.71;
  color: #808080;
}

.duration_hours {
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.4;
  color: #383838;
}

.payment {
  display: flex;
  padding-top: 30px;

  .left {
    width: 37%;
    padding-right: 30px;

    .radio_wrap {
      margin-bottom: 10px;
    }
  }

  .right {
    width: 63%;
    padding-left: 30px;
    border-left: 1px solid #E5E5E5;
  }

  &_item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;

    .desc {
      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      line-height: 1.5;
      color: #383838;
    }

    .price {
      font-family: "Open Sans", sans-serif;
      font-weight: 600;
      font-size: 20px;
      line-height: 1.4;
      color: #383838;

      span {
        font-size: 16px;
      }
    }
  }

  .total {
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-family: "Open Sans", sans-serif;
      font-weight: 600;
      font-size: 16px;
      line-height: 1.5;
      color: #383838;
    }

    .total_price {
      font-family: "Montserrat", sans-serif;
      font-weight: 600;
      font-size: 32px;
      line-height: 125%;
      color: #383838;
    }
  }
}

@media (max-width: 426px) {
  .payment {
    flex-wrap: wrap;
  }

  .payment > .left {
    border-bottom: 1px solid #E5E5E5;
    margin-bottom: 20px;
  }
  .payment > .left, .payment > .right {
    width: 100%;
    padding-left: unset;
    border-left: unset;
  }
}
</style>
